/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ofType } from 'redux-observable';
import { of, combineLatest } from 'rxjs';
import { withLatestFrom, pluck, mergeMap } from 'rxjs/operators';
import values from 'lodash/values';
import isEmpty from 'lodash/isEmpty';
import { isInFlightModificationEnabled } from '../../utils/availabilityGridUtil';
import {
    GET_RESERVATIONS,
    GET_CAMPGROUND,
    SET_CAN_MODIFY_AS_ITINERARY,
} from '../../constants';

/**
 *
 * @param {Observable} action$ - a stream of actions
 * @param {Observable} state$ - a stream of redux store states
 */
export const modifyReservationEpic = (action$, state$) =>
    action$.pipe(
        ofType(
            GET_RESERVATIONS, // when fetching reservation to modify
            GET_CAMPGROUND // when fetching campground
        ),
        withLatestFrom(
            combineLatest(
                state$.pipe(pluck('campground'), pluck('campground'), pluck('results')),
                state$.pipe(pluck('orderDetails'), pluck('pendingReservations')),
                state$.pipe(
                    pluck('internalCamping'),
                    pluck('orderDetails'),
                    pluck('pendingReservations')
                )
            )
        ),
        mergeMap((stream) => {
            const states = stream[1];
            const [campground, reservations /*internalReservations*/] = states;
            const externalReservation = !isEmpty(reservations) && values(reservations)[0];
            const canModifyAsItinerary = isInFlightModificationEnabled(
                campground,
                externalReservation,
                false
            );

            if (campground.facility_id && !isEmpty(externalReservation)) {
                return of({
                    type: SET_CAN_MODIFY_AS_ITINERARY,
                    canModifyAsItinerary: {
                        [externalReservation.reservation_id]: canModifyAsItinerary,
                    },
                });
            }
            return of();
        })
    );
